module.exports = __webpack_public_path__ + "static/support-2ae69f13112887c9eef51210922cb6c8.svg";